function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import MobileZoomImage from './mobileZoomImage';
import MobileZoomText from './mobileZoomText';
import Pincher from './pincher';

var MobileZoom = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MobileZoom, _Component);

  function MobileZoom(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.imageRef = null;
    _this.state = {
      scale: 1,
      position: {
        x: 0,
        y: 0
      }
    };
    return _this;
  }

  var _proto = MobileZoom.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.pincher = new Pincher({
      container: this.props.container,
      allowSwipe: false,
      allowPinch: true,
      toggleZoom: this.props.actions.toggleZoom
    });
    this.pincher.update();
  };

  _proto.getItemWrapperStyle = function getItemWrapperStyle() {
    var initialOffset = this.props.initialOffset;
    var _this$props$current$i = this.props.current.item,
        height = _this$props$current$i.height,
        width = _this$props$current$i.width;
    var dimenstions = {
      height: height,
      width: width,
      position: 'relative'
    };

    var style = _objectSpread({
      backgroundColor: "white",
      position: 'absolute'
    }, initialOffset ? _objectSpread(_objectSpread({}, dimenstions), {}, {
      top: initialOffset
    }) : {
      height: '100%',
      width: '100%'
    });

    return style;
  };

  _proto.getItem = function getItem() {
    var item = this.props.current.item;
    var currentGalleryItem = this.props.currentGalleryItem;

    if (item.type === 'image') {
      return /*#__PURE__*/React.createElement(MobileZoomImage, {
        resizedUrl: currentGalleryItem.createUrl('resized', 'img'),
        item: item,
        currentWindow: this.props.currentWindow
      });
    } else if (item.type === 'text') {
      return /*#__PURE__*/React.createElement(MobileZoomText, {
        item: item,
        currentWindow: this.props.currentWindow
      });
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "mobile-zoom-container",
      style: {
        height: '100%',
        width: '100%',
        backgroundColor: "white",
        position: 'absolute',
        zIndex: 1000
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "mobile-zoom-item-wrapper",
      style: this.getItemWrapperStyle()
    }, this.getItem()));
  };

  return MobileZoom;
}(Component);

export default MobileZoom; //https://izaaca.wixsite.com/mysite-16?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
//https://izaaca.wixsite.com/mysite-16?petri_ovr=specs.pro-gallery.fullscreenAsProGalleryLayout%3Atrue,specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
//art-store
//https://izaaca.wixsite.com/mysite-1/art-store?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js